import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
  Snackbar,
  CircularProgress,
  Tooltip,
  Badge,
} from "@mui/material";
import loginImage from "../../../../assets/img/LoginBg.jpg";
import favicon from "../../../../assets/img/x.png";
import email from "../../../../assets/img/Message.png";
import Lock from "../../../../assets/img/Lock.png";
import eyeOn from "../../../../assets/img/Eyeon.svg";
import eyeOff from "../../../../assets/img/visibilityoff.svg";
import "./login.css";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../../services/api/apiManager";
import { setRenderFolder } from "../../../services/store/slice/ChatSlice";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../../../../Secret";

const Login = () => {
  const token = localStorage.getItem("access_token");
  // State to manage password visibility
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [userName, setUserName] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [usersCredential, setUserCredentials] = useState([]);
  const [loading, setLoading] = useState(false);
  const renderFolder = useSelector((state) => state.chat.renderFolder);
  const [isAddingNewAccount, setIsAddingNewAccount] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState({
    openSnack: false,
    snackMessage: "",
  });
  const navigate = useNavigate();
  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  // Prevent default action on mouse down
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const data = {
    username: userName,
    password: userPassword,
  };

  // Encrypt Function
  const encryptPassword = (password) => {
    return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  };
  // Decrypt Function
  const decryptPassword = (ciphertext) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  };
  // region -- Login Account
  const postAthenticationData = async (data) => {
    setLoading(true);
    try {
      const response = await login(data);
      if (response?.data?.status === 200 && response?.data?.result?.token) {
        // set data in localstorage
        localStorage.setItem("access_token", response?.data?.result?.token);
        localStorage.setItem(
          "picPath",
          response?.data?.result?.user?.profilePicPath
        );
        localStorage.setItem(
          "refresh-token",
          response?.data?.result?.refreshToken
        );
        localStorage.setItem("user_id", response?.data?.result?.user?.userId);
        localStorage.setItem(
          "picPath",
          response?.data?.result?.user?.profilePicPath
        );
        localStorage.setItem(
          "currentLogedInUser",
          JSON.stringify({
            firstName: response?.data?.result?.user?.firstName,
            lastName: response?.data?.result?.user?.lastName,
            usernameorEmail: response?.data?.result?.user?.email,
          })
        );
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify(response?.data?.result?.user?.userId)
          );
        }
        const renderFolderChangeValue = renderFolder === true ? false : true;
        dispatch(setRenderFolder(renderFolderChangeValue));
        const userRoles = response?.data?.result?.userRoles;
        localStorage.setItem(
          "user_roles",
          JSON.stringify(response?.data?.result?.userRoles)
        );
        localStorage.setItem(
          "token_expiry_time",
          response?.data?.result?.expiration
        );
        const firstName = response?.data?.result?.user?.firstName || "";
        const lastName = response?.data?.result?.user?.lastName || "";

        const userNickName = `${firstName} ${lastName}`.trim();

        // ✅ **Encrypt Password Before Saving**
        const encryptedPassword = encryptPassword(userPassword);

        // **Save User Credentials in Array**
        const userData = {
          userId: response?.data?.result?.user?.userId || "",
          email: userName,
          password: encryptedPassword,
          userName: userNickName,
        };
        const existingUsers =
          JSON.parse(localStorage.getItem("MaxChatCredentials")) || [];

        const usersArray = Array.isArray(existingUsers)
          ? existingUsers
          : [existingUsers];

        // **Check if email already exists**
        const isUserExists = usersArray?.some(
          (user) =>
            // user?.email === userData?.email &&
            user?.userName === userData?.userName
        );
        if (isUserExists) {
          // 🛠 **Sirf existing user ka userName update karein, new object insert na ho**
          const updatedUsers = usersArray.map((user) =>
            user.email === userData.email
              ? { ...user, userName: userData.userName }
              : user
          );
          localStorage.setItem(
            "MaxChatCredentials",
            JSON.stringify(updatedUsers)
          );
        } else {
          // ✅ **Agar email new hai to naya object add karein**
          usersArray.push(userData);
          localStorage.setItem(
            "MaxChatCredentials",
            JSON.stringify(usersArray)
          );
        }

        setIsAddingNewAccount(false); // Save and show account view
        if (userRoles.some((ur) => ur.roleName.toLowerCase() === "admin")) {
          navigate("/chats");
        } else {
          navigate("/chats");
        }
        setOpenSnackbar({
          openSnack: false,
          snackMessage: "success",
        });
        setLoading(false);
      } else {
        setOpenSnackbar({
          openSnack: true,
          snackMessage: "error",
        });
        setLoading(false);
      }
    } catch (error) {
      console.warn(error);
      setLoading(false);
    }
  };
  // handle Remove Account
  const handleRemoveAccount = (e, emailToRemove) => {
    e.stopPropagation();
    const savedCredentials = localStorage.getItem("MaxChatCredentials");

    if (savedCredentials) {
      let credentials = JSON.parse(savedCredentials);

      // Ensure it's an array
      if (!Array.isArray(credentials)) {
        credentials = [credentials];
      }

      // Filter out the account to remove
      const updatedCredentials = credentials?.filter(
        (user) => user?.email != undefined && user?.email !== emailToRemove
      );

      // Update localStorage with remaining accounts
      if (updatedCredentials?.length > 0) {
        localStorage.setItem(
          "MaxChatCredentials",
          JSON.stringify(updatedCredentials)
        );
        // setIsAddingNewAccount(false);
      } else {
        localStorage.clear();
        // localStorage.removeItem("MaxChatCredentials"); // Clear localStorage if empty
        setUserName("");
        setUserPassword("");
        setIsAddingNewAccount(true); // Show input fields after removal
      }
      setUserCredentials(updatedCredentials);
    }
  };
  // handle Add Another Account
  const handleAddAnotherAccount = () => {
    setIsAddingNewAccount(true); // Show text fields for a new account
    setUserName("");
    setUserPassword("");
  };
  if (token) {
    navigate("/chats");
  }
  // Autofill UserName & Email
  // useEffect(() => {
  //   const savedCredentials = localStorage.getItem("MaxChatCredentials");
  //   if (savedCredentials) {
  //     const { email, password } = JSON.parse(savedCredentials);
  //     setUserName(email);
  //     setUserPassword(password);
  //   }
  // }, []);
  useEffect(() => {
    const savedCredentials = localStorage.getItem("MaxChatCredentials");

    if (savedCredentials) {
      // Parse data to ensure it's a valid object or array
      const credentials = JSON.parse(savedCredentials);

      // Ensure credentials is an array (for multiple users support)
      const usersArray = Array.isArray(credentials)
        ? credentials
        : [credentials];

      setUserCredentials(usersArray); // Save the array of credentials
      const { email, password } = JSON.parse(savedCredentials);

      if (!isAddingNewAccount) {
        // Only autofill when not adding a new account
        setUserName(email);
        setUserPassword(password);
      }
    }
  }, [isAddingNewAccount]); // Re-run only when toggling accounts
  // Key press
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter" && userName !== "" && userPassword !== "") {
        postAthenticationData(data);
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [userName, userPassword]);
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100dvh",
        backgroundImage: `url(${loginImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        objectFit: "cover",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "30%",
            color: "background.default",
            height: "98vh",
            display: { md: "flex", xs: "none" },
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: "600",
            }}
          >
            Connecting Teams
          </Typography>
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "25px",
              fontWeight: "600",
            }}
          >
            Simplifying Communication
          </Typography>
          <Typography
            sx={{
              fontFamily: "Poppins, sans-serif",
              marginTop: "10px",
              fontSize: "16px",
            }}
          >
            Our communication platform streamlines interactions with secure
            messaging, email management, audio/video calls, and collaboration
            tools. With a user-friendly interface, our system adapts to modern
            needs, ensuring reliable and effective communication.
          </Typography>
        </Box>
        <Paper
          elevation={3}
          // sx={{
          //   //position: "absolute",
          //   // top: "50%",
          //   // left: "50%",
          //   //transform: "translate(-50%, -50%)",
          //   marginTop: { md: "0", xs: "175px" },
          //   padding: { xl: "45px 31px", xs: "35px 31px" },
          //   backgroundColor: "#e0f3f9",
          //   borderRadius: "30px",
          //   textAlign: "center",
          //   width: {
          //     xl: "26%",
          //     lg: "28%",
          //     md: "40%",
          //     sm: "50%",
          //     xs: "75%",
          //   },
          //   height: "100%",
          // }}
          sx={(theme) => ({
            marginTop: { md: "0", xs: "0" },
            padding: { xl: "45px 31px", xs: "35px 31px" },
            backgroundColor: "#e0f3f9",
            borderRadius: "30px",
            textAlign: "center",
            width: {
              xl: "26%",
              lg: "28%",
              md: "40%",
              sm: "50%",
              xs: "75%",
            },
            height: "auto", // Allow natural height

            // Default layout for larger screens
            display: "block",

            // Centering for mobile screens
            [theme.breakpoints.down("sm")]: {
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            },
          })}
        >
          {/* {loading ? (
          <div style={{ padding: "5.5rem 0" }} className="loading-container">
            <div className="logo-container">
              <img className="logo" src={favicon} alt="Website Logo" />
            </div>
          </div>
        ) : ( */}
          <Box pt={2.5} pb={2.5}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={favicon}
                alt="Description of the image"
                style={{
                  mixBlendMode: "multiply",
                  backgroundColor: "transparent",
                }}
              />
            </Box>
            <Typography
              variant="h5"
              component="h1"
              style={{ fontWeight: "600" }}
            >
              <span style={{ color: "#2f2f2f", fontSize: "20px" }}>
                Welcome Back!
              </span>
            </Typography>
            <Typography
              variant="h6"
              component="h1"
              style={{ fontSize: "14px" }}
              pt={0.5}
            >
              <span style={{ color: "#90919b" }}>Login To Your Account</span>
            </Typography>
            <Box pt={6}>
              <ThemeProvider theme={theme}>
                {/* User Save Info Design */}
                {usersCredential?.length > 0 && !isAddingNewAccount ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                        alignItems: "center",
                        height: "170px",
                        overflowY: "auto",
                        pt: "12px",
                      }}
                    >
                      {usersCredential &&
                        usersCredential
                          ?.filter((i) => i?.email !== undefined)
                          ?.map((items) => {
                            return (
                              <Box
                                sx={{
                                  width: "100%",
                                }}
                              >
                                <Badge
                                  badgeContent={
                                    <Tooltip
                                      title="Remove Account"
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={(e) => {
                                          handleRemoveAccount(e, items?.email);
                                        }}
                                        sx={{ m: "0", p: "0" }}
                                      >
                                        <CancelIcon
                                          sx={{
                                            color: "#F50B5C",
                                            fontSize: "25px",
                                            borderRadius: "1rem",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  }
                                  // color="primary"
                                  sx={{ width: "70%" }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      m: "0 auto",
                                      gap: 1,
                                      p: 1,
                                      borderRadius: "12px",
                                      border: "1px solid black",
                                      backgroundColor: "#2560A5",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                      width: "100%",
                                      // maxWidth: 390,
                                      transition: "all 0.3s",
                                      cursor: "pointer",
                                      "&:hover": {
                                        boxShadow:
                                          "0px 6px 15px rgba(0, 0, 0, 0.15)",
                                      },
                                    }}
                                    onClick={() => {
                                      // 🔄 **Update Login Data with Decrypted Password**
                                      const decryptedPassword = decryptPassword(
                                        items?.password
                                      );
                                      const data = {
                                        username: items?.email,
                                        password: decryptedPassword,
                                      };
                                      postAthenticationData(data);
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          color: "white",
                                        }}
                                      >
                                        {items?.userName}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontSize: "12px",
                                          color: "whitesmoke",
                                        }}
                                      >
                                        {items?.email}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Badge>
                              </Box>
                            );
                          })}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "1rem",
                        alignItems: "center",
                        padding: "0.5rem",
                        mt: "0.2rem",
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          handleAddAnotherAccount();
                        }}
                        sx={{ m: "0", p: "0" }}
                      >
                        <AddCircleRoundedIcon
                          sx={{
                            color: "#081E40",
                            fontSize: "25px",
                            borderRadius: "0.5rem",
                          }}
                        />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          color: "#081E40",
                          fontWeight: "bold",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                        onClick={() => {
                          handleAddAnotherAccount();
                        }}
                      >
                        Add another account
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box pt={2}>
                      <TextField
                        value={userName}
                        onChange={(e) => {
                          setUserName(e.target.value);
                        }}
                        variant="outlined"
                        fullWidth
                        placeholder="Username/Email"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              {/* <MailIcon /> */}
                              <img
                                src={email}
                                alt="Description of the image"
                                className="icons-width"
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <Box pt={2.5}>
                      <ThemeProvider theme={theme}>
                        <Box style={{ position: "relative" }}>
                          <TextField
                            value={userPassword}
                            onChange={(e) => {
                              setUserPassword(e.target.value);
                            }}
                            sx={{
                              "& input[type='password']::-ms-reveal, & input[type='password']::-ms-clear":
                                {
                                  display: "none",
                                },
                            }}
                            variant="outlined"
                            placeholder="Password"
                            type={showPassword ? "text" : "password"}
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <img
                                    src={Lock}
                                    alt="Description of the image"
                                    className="icons-width"
                                  />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <img
                                    src={eyeOn}
                                    alt="Hide password"
                                    className="icons-width"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      display: showPassword ? "block" : "none",
                                    }}
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  />
                                  <img
                                    src={eyeOff}
                                    alt="Show password"
                                    className="icons-width"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      display: showPassword ? "none" : "block",
                                    }}
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                      </ThemeProvider>
                    </Box>
                    <Box pt={3}>
                      <Button
                        disabled={
                          userPassword !== "" && userName !== "" ? false : true
                        }
                        variant="contained"
                        className="btn"
                        onClick={() => {
                          postAthenticationData(data);
                        }}
                      >
                        {loading ? (
                          <CircularProgress
                            sx={{ color: "white" }}
                            size="25px"
                          />
                        ) : (
                          "Log in"
                        )}
                      </Button>
                    </Box>
                  </>
                )}
              </ThemeProvider>
            </Box>
            {/* <Box pt={2}>
              <Typography className="textrecover" sx={{ fontSize: "13px" }}>
                <Link
                  to="/recover"
                  style={{
                    fontSize: "13px",
                    textDecoration: "none",
                    color: "#095f99",
                  }}
                >
                  Recover Password
                </Link>
              </Typography>
            </Box> */}
            {/* <Box pt={4}>
            <Typography>
              <Box className="text-center" pt={3} sx={{ fontSize: "14px" }}>
                Don't have an account?{" "}
                <Link
                  to="/signup"
                  style={{
                    textDecoration: "none",
                    color: "#095f99",
                    fontWeight: "600",
                  }}
                >
                  Sign Up
                </Link>
              </Box>
            </Typography>
          </Box> */}
          </Box>
          {/* )} */}
        </Paper>
      </Box>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar?.openSnack}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar({ openSnack: false, snackMessage: "" })}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
      >
        <Alert
          onClose={() =>
            setOpenSnackbar({ openSnack: false, snackMessage: "" })
          }
          severity={
            openSnackbar?.snackMessage === "success" ? "success" : "error"
          }
          variant="filled"
          sx={{
            width: "100%",
            height: "2.5rem",
            textAlign: "center",
            fontSize: "0.9rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "1.2rem",
          }}
          action={
            <>
              <span
                onClick={() =>
                  setOpenSnackbar({ openSnack: false, snackMessage: "" })
                }
                style={{
                  cursor: "pointer",
                  m: "auto 0",
                  fontSize: "13px",
                  color: "rgb(231, 231, 231)",
                }}
              >
                Close
              </span>
            </>
          }
        >
          {openSnackbar.snackMessage === "success"
            ? "Successfully login"
            : "Invalid Credentials, Please Try again"}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;
const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px",
            backgroundColor: "#f6f7fb",
            "& input": {
              padding: "6px 12px",
              fontSize: "12px",
              height: "30px",
              backgroundColor: "#f6f7fb",
            },
            "& fieldset": {
              borderColor: "#f6f7fb",
            },
            "&:hover fieldset": {
              borderColor: "#f6f7fb",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#f6f7fb",
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: "4px 8px",
        },
      },
    },
  },
});
